import { useReduxAccount } from "./useReduxAccount.jsx";

export const useGetPaymentStatus = () => {
    const { free, registration_date, next_subscription_date } = useReduxAccount();

    const deadline_14days = new Date(Number(next_subscription_date) || Date.parse(registration_date));
    deadline_14days.setDate(deadline_14days.getDate() + 7);

    const deadline_28days = new Date(deadline_14days);
    deadline_28days.setDate(deadline_28days.getDate() + 14);

    const deadline_42days = new Date(deadline_28days);
    deadline_42days.setDate(deadline_28days.getDate() + 14);

    const needToPay = next_subscription_date
        ? next_subscription_date <= Date.now() && Date.now() < deadline_28days
        : Date.parse(registration_date) < deadline_28days;

    const notPayed = Date.now() >= deadline_28days;

    const daysToPublicBlock = Math.floor((deadline_14days - Date.now()) / (24 * 60 * 60 * 1000));
    const daysToAdminBlock = Math.floor((deadline_28days - Date.now()) / (24 * 60 * 60 * 1000));
    const daysToDeleteAccount = Math.floor((deadline_42days - Date.now()) / (24 * 60 * 60 * 1000));

    return {
        free,
        needToPay,
        notPayed,
        deadline_28days,
        daysToPublicBlock,
        daysToAdminBlock,
        daysToDeleteAccount,
    };
};
